// extracted by mini-css-extract-plugin
export var brand = "_84-9";
export var compact = "_84-6";
export var extraSmall = "_84-7";
export var icon = "_84-0";
export var large = "_84-4";
export var light = "_84-1";
export var medium = "_84-5";
export var outline = "_84-b";
export var primaryDark = "_84-a";
export var primaryLight = "_84-8";
export var primaryModern = "_84-c";
export var success = "_84-2";
export var successSolid = "_84-3";